/* Striscia di schede: le linguette del prototipo.
 *
 * Sta fra i condivisi perché la usano due schermate — le catene del wallet e
 * le sezioni delle impostazioni — con lo stesso identico markup. Era nata in
 * `pagine/wallet/` e importata da lì anche dalle impostazioni: una schermata
 * che dipende dai file interni di un'altra è una copia che aspetta di nascere.
 *
 * Ogni linguetta è un tocco da 44px anche quando il testo è corto: sotto quella
 * misura, su un telefono in mano, si cambia catena per sbaglio. La striscia
 * scorre in orizzontale invece di andare a capo: sotto i 390px otto catene a
 * capo spingerebbero i saldi sotto la piega.
 */

export interface VoceScheda {
  chiave: string;
  etichetta: string;
  /** Numero o stato accanto all'etichetta: dice il costo di aprirla prima di aprirla. */
  nota?: string;
  /** Segnala una linguetta che chiede attenzione (gas basso, catena muta). */
  attenzione?: boolean;
}

export function StrisciaSchede({
  voci,
  attiva,
  onScegli,
  etichetta,
}: {
  voci: VoceScheda[];
  attiva: string;
  onScegli: (chiave: string) => void;
  /** Nome del gruppo per chi naviga con lo screen reader. */
  etichetta: string;
}) {
  return (
    <div className="sb-schede" role="tablist" aria-label={etichetta}>
      {voci.map((v) => {
        const on = v.chiave === attiva;
        return (
          <button
            key={v.chiave}
            type="button"
            role="tab"
            aria-selected={on}
            className={`sb-schede__voce${on ? ' sb-schede__voce--attiva' : ''}`}
            onClick={() => onScegli(v.chiave)}
          >
            <span>{v.etichetta}</span>
            {v.nota && (
              <span
                className={`sb-schede__nota${v.attenzione ? ' sb-schede__nota--attenzione' : ''}`}
              >
                {v.nota}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
